module.exports = __webpack_public_path__ + "static/media/ActualTrash.321df6c0.webp";